<div class="card">
    <div class="card-placeholder">
        <div class="card-placeholder-body">
            <div class="card-placeholder-body-top-section">
                <div class="card-placeholder-body-top-section-text-container">
                    <ng-content select="[fcpStoreCardTitle]"></ng-content>
                    <ng-content select="[fcpStoreCardContent]"></ng-content>
                </div>
                <ng-content select="[fcpStoreCardSelector]"></ng-content>
            </div>
            <ng-content select="[fcpStoreCardFooter]"></ng-content>
        </div>
    </div>
</div>
